// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IAnswer } from './iAnswer.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IQuestion {
    'key': string;
    'answers': Array<IAnswer>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IQuestion>> = [
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "answers",
            "baseName": "answers",
            "type":     "Array<IAnswer>"
        },
    ];

    static getAttributeTypeMap() {
        return IQuestion.attributeTypeMap;
    }
}
